function DadosContatoPanel({ inscricao, renderCampo }) {
  return (
    <>
      <h5 style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
        Dados de Contato
      </h5>
      {renderCampo("E-mail", inscricao.email)}
      {renderCampo("Celular", inscricao.celular)}
    </>
  );
}

export default DadosContatoPanel;